import React from 'react';
import NavIcons from './NavIcons';

function StickyHeader(props) {
	return (
		<div className="sticky-header">
				<NavIcons colorMode="white" includeLogo="true" includeIcons="false" />
		</div>)
}
export default StickyHeader;
